export const bankData = [
	{
		id: 1,
		bankName: '농협은행',
		image: '/assets/images/banks/nh.svg',
	},
	{
		id: 2,
		bankName: 'KB국민은행',
		image: '/assets/images/banks/kb.svg',
	},
	{
		id: 3,
		bankName: '신한은행',
		image: '/assets/images/banks/sinHan.svg',
	},
	{
		id: 4,
		bankName: '카카오뱅크',
		image: '/assets/images/banks/kakaoBank.svg',
	},
	{
		id: 5,
		bankName: '우리은행',
		image: '/assets/images/banks/woori.svg',
	},
	{
		id: 6,
		bankName: '하나은행',
		image: '/assets/images/banks/hana.svg',
	},
	{
		id: 7,
		bankName: '토스뱅크',
		image: '/assets/images/banks/toss.svg',
	},
	{
		id: 8,
		bankName: '새마을금고',
		image: '/assets/images/banks/saeMaul.svg',
	},
	{
		id: 9,
		bankName: 'IBK기업은행',
		image: '/assets/images/banks/ibk.svg',
	},
	{
		id: 10,
		bankName: '케이뱅크',
		image: '/assets/images/banks/kbank.svg',
	},
	{
		id: 11,
		bankName: '우체국',
		image: '/assets/images/banks/postOffice.svg',
	},
	{
		id: 12,
		bankName: 'SC제일은행',
		image: '/assets/images/banks/sc.svg',
	},
	{
		id: 13,
		bankName: '전북은행',
		image: '/assets/images/banks/jb.svg',
	},
	{
		id: 14,
		bankName: '신협',
		image: '/assets/images/banks/sinhyep.svg',
	},
	{
		id: 15,
		bankName: '경남은행',
		image: '/assets/images/banks/gn.svg',
	},
	{
		id: 16,
		bankName: '광주은행',
		image: '/assets/images/banks/gj.svg',
	},
	{
		id: 17,
		bankName: '부산은행',
		image: '/assets/images/banks/bs.svg',
	},
	{
		id: 18,
		bankName: '수협은행',
		image: '/assets/images/banks/soohyep.svg',
	},
	{
		id: 19,
		bankName: 'KDB산업은행',
		image: '/assets/images/banks/kdb.svg',
	},
	{
		id: 20,
		bankName: '대구은행',
		image: '/assets/images/banks/dg.svg',
	},
	{
		id: 21,
		bankName: '산림조합은행',
		image: '/assets/images/banks/sj.svg',
	},
	{
		id: 22,
		bankName: '제주은행',
		image: '/assets/images/banks/jj.svg',
	},
];
